// Revisado: 2026-01-03 [I18n Scan]
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ReportBugModal from '../reports/ReportBugModal';

const Footer = () => {
  const { t } = useTranslation();
  const [isReportOpen, setIsReportOpen] = useState(false);

  return (
    <footer className="w-full bg-white border-t border-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col items-center gap-4 text-sm text-gray-500">

        {/* Top Row: Main Info */}
        <div className="flex flex-col items-center gap-1 text-center">
          <span>{t('Footer.based_on')} <span className="font-semibold text-gray-700">Umamusume: Pretty Derby</span></span>

          <div className="flex items-center gap-2">
            <span>{t('Footer.winners_of')}</span>
            <a
              href="https://x.com/umamusume_eng/status/1999286509720207814"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-blue-600 hover:text-blue-800 transition-colors hover:underline"
            >
              "The Game Awards 2025"
            </a>
          </div>
        </div>

        {/* Middle Row: Report Bug (Separate Line) */}
        <div className="flex flex-col items-center gap-2">
          <button
            onClick={() => setIsReportOpen(true)}
            className="text-xs text-gray-400 hover:text-red-500 transition-colors flex items-center gap-1 opacity-60 hover:opacity-100 py-1"
            title={t('Footer.tooltip_report')}
            aria-label={t('Footer.aria_report')}
          >
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>{t('Footer.report_error')}</span>
          </button>

          {/* Disclaimer requested by User */}
          <p className="text-[10px] text-gray-400 text-center max-w-xl opacity-70 italic">
            {t('Footer.dev_disclaimer')}
          </p>
        </div>

        {/* Bottom Row: Copyright Disclaimer */}
        <div className="text-xs text-gray-400 text-center border-t border-gray-100 w-full pt-4 mt-2">
          {t('Footer.copyright')}
          <span className="mx-2">•</span>
          <Link to="/about" className="hover:text-gray-600 transition-colors">
            {t('Footer.about_link', 'About / Acerca de')}
          </Link>
        </div>
      </div>

      <ReportBugModal isOpen={isReportOpen} onClose={() => setIsReportOpen(false)} />
    </footer>
  );
};

export default Footer;